import { render } from "./LockerEventMode.vue?vue&type=template&id=8b9c62e0"
import script from "./LockerEventMode.vue?vue&type=script&lang=js"
export * from "./LockerEventMode.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mac/Projects/webshop/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__